/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import {
    QuestionaryInfo,
    QuestionaryItemInfo,
    QuestionaryRequestFilter,
    QuestionaryTable,
} from 'models/api/questionary';
import ResTable from 'models/api/table';
import { Key } from 'react';

export const getQuestionary = async (axios: AxiosInstance, params: QuestionaryRequestFilter) => {
    const { data } = await axios.get<ResTable<QuestionaryTable>>('/Questionary', {
        params,
    });
    return data;
};

export const getQuestionaryAll = async (axios: AxiosInstance) => {
    const { data } = await axios.get<QuestionaryInfo[]>('/Questionary/all');
    return data;
};

export const getQuestionaryExcel = async (
    axios: AxiosInstance,
    params: QuestionaryRequestFilter
) => {
    const { data } = await axios.get<Blob>('/Questionary/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getQuestionaryItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<QuestionaryInfo>(`/Questionary/${id}`);
    return data;
};

export const getQuestionaryItemList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<QuestionaryItemInfo[]>('/Questionary/itemList');
    return data;
};

export const getTradeOrgList = async (axios: AxiosInstance, name: string | null) => {
    const { data } = await axios.get<DropDown[]>('/Questionary/tradeOrgList', {
        params: { name },
    });
    return data;
};

export const getOutletList = async (axios: AxiosInstance, id: Key, name: string | null) => {
    const { data } = await axios.get<DropDown[]>('/Questionary/outletList', {
        params: { id, name },
    });
    return data;
};

export const addQuestionaryItem = async (axios: AxiosInstance, item: QuestionaryInfo) => {
    return await axios.post('/Questionary', item);
};

export const changeQuestionaryItem = async (axios: AxiosInstance, item: QuestionaryInfo) => {
    return await axios.put(`/Questionary/${item.id}`, item);
};

export const deleteQuestionaryItem = async (axios: AxiosInstance, id: Key) => {
    return await axios.delete(`/Questionary/${id}`);
};
